import { render, staticRenderFns } from "./TradingLayout.vue?vue&type=template&id=080f4ac4&"
import script from "./TradingLayout.vue?vue&type=script&lang=js&"
export * from "./TradingLayout.vue?vue&type=script&lang=js&"
import style0 from "./TradingLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports